import {
    BodyScrollEvent,
    GetContextMenuItemsParams,
    GridOptions,
    ProcessRowParams,
    RowDataTransaction,
    ValueFormatterParams,
} from '@ag-grid-community/core';
import {
    COL_DEF_CCY_PAIR,
    COL_DEF_CLIENT,
    COL_DEF_COUNTER_FILLED_AMOUNT,
    COL_DEF_COUNTER_FILLED_AMOUNT_CURRENCY,
    COL_DEF_CREATED_DATE,
    COL_DEF_DEAL_NUMBER,
    COL_DEF_EXECUTION_DATE,
    COL_DEF_EXPIRY_DATE,
    COL_DEF_EXPIRY_TYPE,
    COL_DEF_FAR_AMOUNT,
    COL_DEF_FAR_AMOUNT_CURRENCY,
    COL_DEF_FAR_COUNTER_FILLED_AMOUNT,
    COL_DEF_FAR_COUNTER_FILLED_AMOUNT_CURRENCY,
    COL_DEF_FAR_POINTS,
    COL_DEF_FAR_PRICE,
    COL_DEF_FAR_VALUE_DATE,
    COL_DEF_FILL_PERCENT,
    COL_DEF_FILLED_AMOUNT,
    COL_DEF_FILLED_AMOUNT_CURRENCY,
    COL_DEF_FILLED_PRICE,
    COL_DEF_ID,
    COL_DEF_LEFT_AMOUNT,
    COL_DEF_LEFT_AMOUNT_CURRENCY,
    COL_DEF_MKT_PERCENT,
    COL_DEF_MKT_POINTS,
    COL_DEF_NEAR_AMOUNT,
    COL_DEF_NEAR_AMOUNT_CURRENCY,
    COL_DEF_NEAR_POINTS,
    COL_DEF_NEAR_PRICE,
    COL_DEF_NEAR_VALUE_DATE,
    COL_DEF_PENDING_LEG_TYPE,
    COL_DEF_PENDING_STRATEGY,
    COL_DEF_PENDING_STRATEGY_ID,
    COL_DEF_PRODUCT,
    COL_DEF_REQUESTED_AMOUNT,
    COL_DEF_REQUESTED_AMOUNT_CURRENCY,
    COL_DEF_REQUESTED_PRICE,
    COL_DEF_SIDE,
    COL_DEF_SIDE_SWAP,
    COL_DEF_SPOT_RATE,
    COL_DEF_SPOT_TYPE,
    COL_DEF_STATUS,
    COL_DEF_TRADER,
    COL_DEF_VALUE_DATE,
} from './blotter.service.data';
import { ExpiryTypes } from '@fnx/fx-pad';
import { IBlotterTransaction, IBlotterUpdate, IOrderReport, ORDER_KEY, OrderReportType } from '../../interfaces';
import { IColDef, ISideAndOrderTypeCellRendererValue } from '.';
import { IGridScrollService } from '../grid-scroll';
import { Predicate } from '../../interfaces/functions.interface';
export const getFilteredTransaction = (update: IBlotterUpdate): IBlotterUpdate => {
    return update;
};
import { BCP47 } from '@alk/numbers';
import { EBlotterTab } from '../../enums';
import { formatPointsByLocaleNoTruncate } from '../../helpers';
import { IGridContextMenuService } from '../grid-context-menu';

export function getSyncTransaction(changeSet: IBlotterUpdate): RowDataTransaction {
    return {
        add: changeSet.newItems,
        remove: changeSet.deletedKeys?.map(key => ({ [ ORDER_KEY ]: key })),
    };
}

export function getBlotterSpotColumnDefs(): Array<IColDef> {
    return [
        COL_DEF_STATUS,
        COL_DEF_FILL_PERCENT,
        COL_DEF_PENDING_STRATEGY_ID,
        COL_DEF_PENDING_STRATEGY,
        COL_DEF_SPOT_TYPE,
        COL_DEF_ID,
        {
            ...COL_DEF_DEAL_NUMBER,
            hide: true,
        },
        COL_DEF_TRADER,
        COL_DEF_CLIENT,
        COL_DEF_SIDE,
        COL_DEF_CCY_PAIR,
        {
            ...COL_DEF_REQUESTED_AMOUNT,
            hide: true,
        },
        COL_DEF_REQUESTED_AMOUNT_CURRENCY,
        COL_DEF_FILLED_AMOUNT,
        COL_DEF_FILLED_AMOUNT_CURRENCY,
        {
            ...COL_DEF_LEFT_AMOUNT,
            hide: true,
        },
        COL_DEF_LEFT_AMOUNT_CURRENCY,
        COL_DEF_COUNTER_FILLED_AMOUNT,
        COL_DEF_COUNTER_FILLED_AMOUNT_CURRENCY,
        {
            ...COL_DEF_REQUESTED_PRICE,
            hide: true,
        },
        COL_DEF_FILLED_PRICE,
        COL_DEF_VALUE_DATE,
        COL_DEF_CREATED_DATE,
        COL_DEF_EXECUTION_DATE,
    ];
}

export function getBlotterForwardColumnDefs(): Array<IColDef> {
    return [
        COL_DEF_STATUS,
        COL_DEF_FILL_PERCENT,
        COL_DEF_PRODUCT,
        COL_DEF_ID,
        {
            ...COL_DEF_DEAL_NUMBER,
            hide: true,
        },
        COL_DEF_TRADER,
        COL_DEF_CLIENT,
        COL_DEF_SIDE_SWAP,
        COL_DEF_CCY_PAIR,
        COL_DEF_NEAR_AMOUNT,
        COL_DEF_NEAR_AMOUNT_CURRENCY,
        COL_DEF_SPOT_RATE,
        COL_DEF_NEAR_POINTS,
        COL_DEF_NEAR_PRICE,
        {
            ...COL_DEF_COUNTER_FILLED_AMOUNT,
            headerName: 'Near Amount (Counter Ccy)',
        },
        {
            ...COL_DEF_COUNTER_FILLED_AMOUNT_CURRENCY,
            headerName: 'Near Amount (Counter Ccy) Currency',
        },
        COL_DEF_NEAR_VALUE_DATE,
        COL_DEF_FAR_AMOUNT,
        COL_DEF_FAR_AMOUNT_CURRENCY,
        COL_DEF_FAR_POINTS,
        COL_DEF_FAR_PRICE,
        COL_DEF_FAR_COUNTER_FILLED_AMOUNT,
        COL_DEF_FAR_COUNTER_FILLED_AMOUNT_CURRENCY,
        COL_DEF_FAR_VALUE_DATE,
        COL_DEF_CREATED_DATE,
        COL_DEF_EXECUTION_DATE,
    ];
}

export function getBlotterPendingColumnDefs(): Array<IColDef> {
    return [
        COL_DEF_STATUS,
        COL_DEF_FILL_PERCENT,
        COL_DEF_MKT_PERCENT,
        COL_DEF_MKT_POINTS,
        COL_DEF_PENDING_STRATEGY_ID,
        COL_DEF_PENDING_STRATEGY,
        COL_DEF_PENDING_LEG_TYPE,
        COL_DEF_ID,
        {
            ...COL_DEF_DEAL_NUMBER,
            hide: true,
        },
        COL_DEF_TRADER,
        COL_DEF_CLIENT,
        COL_DEF_SIDE,
        COL_DEF_CCY_PAIR,
        COL_DEF_REQUESTED_AMOUNT,
        COL_DEF_REQUESTED_AMOUNT_CURRENCY,
        {
            ...COL_DEF_FILLED_AMOUNT,
            hide: true,
        },
        COL_DEF_FILLED_AMOUNT_CURRENCY,
        COL_DEF_LEFT_AMOUNT,
        COL_DEF_LEFT_AMOUNT_CURRENCY,
        COL_DEF_COUNTER_FILLED_AMOUNT,
        COL_DEF_COUNTER_FILLED_AMOUNT_CURRENCY,
        COL_DEF_REQUESTED_PRICE,
        COL_DEF_CREATED_DATE,
        COL_DEF_EXPIRY_TYPE,
        COL_DEF_EXPIRY_DATE,
        COL_DEF_EXECUTION_DATE,
    ];
}

export const commonGridOptions: GridOptions = {
    defaultColDef: {
        resizable: true,
        sortable: true,
        filter: true,
    },
    autoGroupColumnDef: {
        headerName: '',
    },
    rowData: [],
    sideBar: {
        toolPanels: [
            {
                id: 'columns',
                labelDefault: '',
                labelKey: 'columns',
                iconKey: 'columns',
                toolPanel: 'agColumnsToolPanel',
                toolPanelParams: {
                    suppressRowGroups: true,
                    suppressValues: true,
                    suppressPivots: true,
                    suppressPivotMode: true,
                    suppressColumnExpandAll: true,
                },
            },
        ],
        hiddenByDefault: true,
    },
    statusBar: {
        statusPanels: [
            {
                statusPanel: 'agAggregationComponent',
                align: 'right',
            },
        ],
    },
    rowGroupPanelShow: 'always',
    enableRangeSelection: true,
    scrollbarWidth: 6,
    rowHeight: 28,
    asyncTransactionWaitMillis: 100,
    suppressColumnVirtualisation: true,
};

export const getOrdersGridOptions = (options?: {
    isRowActionsEnabled?: boolean,
    gridScrollSrv?: IGridScrollService,
    gridContextMenuSrv?: IGridContextMenuService,
    gridType?: EBlotterTab,
}): GridOptions => ({
    ...commonGridOptions,
    getRowId: (params) => params?.data[ ORDER_KEY ],
    processRowPostCreate: (params: ProcessRowParams) => {
        if (options?.isRowActionsEnabled && !params.eRow?.classList.contains('ag-row-group')) {
            const elm = document.createElement('sfx-web-row-actions-for-pending-orders');
            elm.rowElm = params.eRow;
            elm.viewportElm = params.eRow?.parentElement?.parentElement;
            // NOTE: AgGrid mutate the data object and we don't want that on the component
            elm.orderDetails = { ...params.node?.data };
            params.eRow?.append(elm);
        }
    },
    onBodyScroll: ({ direction, top, left }: BodyScrollEvent) => {
        if (Boolean(options) && Boolean(options.gridScrollSrv)) {
            options.gridScrollSrv.next({
                direction: direction as 'horizontal' | 'vertical',
                top,
                left,
            });
        }
    },
    getContextMenuItems: (params: GetContextMenuItemsParams) => {
        const menuItemsParams = {
            gridType: options.gridType,
            defaultItems: params.defaultItems,
            dataItem: params.node?.data,
        };
        return Boolean(options) && Boolean(options.gridType) && Boolean(options.gridContextMenuSrv) ?
            options.gridContextMenuSrv.getMenuItems(menuItemsParams) :
            params.defaultItems;
    },
});

export const accumulatedFilteredUpdate =
    (filter: Predicate<IOrderReport>) =>
        (
            { allOrders: allFilteredOrders }: IBlotterUpdate,
            { allOrders, deletedKeys, newItems, updated, flush }: IBlotterUpdate,
        ): IBlotterUpdate => {

            const accumulatedOrders = allFilteredOrders ?? new Map<IOrderReport[typeof ORDER_KEY], IOrderReport>();

            //on init should populated filtered map and all item place as newItems
            if (!Boolean(allFilteredOrders)) {
                allOrders?.forEach((value, key) => {
                    if (filter(value)) {
                        accumulatedOrders.set(key, value);
                    }
                });
                return {
                    flush,
                    newItems: [ ...accumulatedOrders?.values() ?? [] ],
                    allOrders: accumulatedOrders,
                };
            }

            if (flush) {
                accumulatedOrders?.clear();
                return {
                    flush,
                    allOrders: accumulatedOrders,
                };
            }

            const updateDeleted = [];
            deletedKeys?.filter(key => accumulatedOrders?.has(key))?.forEach(dKey => {
                updateDeleted.push(dKey);
                accumulatedOrders.delete(dKey);
            });

            const updateNew = [];

            newItems
                ?.filter(filter)
                ?.forEach(nItem => {
                    updateNew.push(nItem);
                    accumulatedOrders.set(nItem.orderId, nItem);
                });

            const { deletedKeys: dItems, newItems: nItems, updated: uItems } = updated?.reduce<
            Pick<IBlotterTransaction, 'newItems' | 'deletedKeys' | 'updated'>
            >(
                (accum, cur) => {

                    const filterResult = filter(allOrders.get(cur.orderId));

                    if (//update make new item if ...
                        !accumulatedOrders.has(cur.orderId) && //order not already presented
                        filterResult //order not filtered out
                    ) {
                        accum.newItems.push(allOrders.get(cur.orderId));
                        accumulatedOrders.set(cur.orderId, allOrders.get(cur.orderId));
                        return accum;
                    }

                    if (//update delete item if ...
                        accumulatedOrders.has(cur.orderId) && //order already presented
                        !filterResult //order filtered out
                    ) {
                        accum.deletedKeys.push(cur.orderId);
                        accumulatedOrders.delete(cur.orderId);
                        return accum;
                    }

                    if (//update update item if ...
                        accumulatedOrders.has(cur.orderId) && //order already presented
                        filterResult //order not filtered out
                    ) {
                        accum.updated.push(cur);
                        accumulatedOrders.set(cur.orderId, allOrders.get(cur.orderId));
                        return accum;
                    }

                    return accum;
                },
                { newItems: [], updated: [], deletedKeys: [] },
            ) ?? { newItems: [], updated: [], deletedKeys: [] };

            return {
                allOrders: accumulatedOrders,
                newItems: [ ...updateNew, ...nItems ],
                updated: uItems,
                deletedKeys: [ ...updateDeleted, ...dItems ],
                flush,
            };
        };

export const nonEmptyUpdate =
    ({ deletedKeys, newItems, updated, flush }: IBlotterUpdate): boolean =>
        flush ||
        Boolean(newItems?.length) ||
        Boolean(updated?.length) ||
        Boolean(deletedKeys?.length)
        ;

export const orderTypeDescriptionMap: Record<OrderReportType, string> = {
    spot: 'Spot',
    forward: 'Forward',
    swap: 'FX Swap',
};

export const expiryTypeDescriptionMap: Record<ExpiryTypes, string> = {
    gtc: 'GTC',
    gtd: 'GTD',
    gts: 'GTS',
    fok: 'FOK',
    ioc: 'IOC',
    unknown: 'Unknown',
};

export const sideOrderSwapMap: Record<string, string> = {
    Sell: 'Buy/Sell',
    Buy: 'Sell/Buy',
};

export const overrideHeaderNameWithBrandingConf = (
    mapping: Record<string, string> = {},
) => (colDef: IColDef): IColDef => {
    const overridedHeaderName = mapping[ colDef.field ];

    return Boolean(overridedHeaderName) ?
        {
            ...colDef,
            headerName: overridedHeaderName,
        } :
        colDef;
};

export function sideCellValueFormatter(params: ValueFormatterParams): string {
    if (params.node?.group) {
        return undefined;
    }

    const data = params.data as ISideAndOrderTypeCellRendererValue;
    const side = data.side;

    if (data.orderType === 'swap') {
        return sideOrderSwapMap[ side ];
    }

    return side ;
}

export function priceAndPointsValueFormatter(params: ValueFormatterParams): string {
    const value = params?.value;
    return value !== undefined && value !== null ?
        formatPointsByLocaleNoTruncate(navigator.language as BCP47)(value) :
        '-';
}
